export enum PatientTableColumnDataIndex {
  FirstName = "firstName",
  LastName = "lastName",
  Birthday = "birthday",
  ProgramName = "programName",
  GDPR = "gdpr",
  Action = "action",
}
